<!--
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: zhujuan
 * @LastEditTime: 2022-01-19 14:09:34
 * @FilePath: /nqc-pc-ui/src/common/components/Screenfull/index.vue
-->
<template>
  <div>dd</div>
</template>

<script>
export default {
  name: 'Demo',
  components: {},
  data() {
    return {}
  },
  mounted() {},

  created() {},

  methods: {}
}
</script>
<style lang="scss" scoped></style>
